import { PossibleInfo } from '../constants'
import { userPurchases } from '../userPurchases/userPurchases'

export const getInactivePurchases = async ({
	token,
	languageISO,
	countryISO,
	channel,
}: {
	token: string
	languageISO: string
	countryISO: string
	channel: string
}) => {
	let inactiveOrder
	try {
		inactiveOrder = await userPurchases.inactivePurchases.apiFetch({
			token,
			languageISO,
			countryISO,
			channel,
		})
	} catch (err) {
		console.error('Error fetching user info')
	}
	return {
		action: inactiveOrder,
		actionType: PossibleInfo.INACTIVE_PURCHASE,
	}
}
